import { useEffect } from 'react';
import { connect } from 'react-redux';
import './PublicLayout.scss';

function PublicLayout({ ...props }) {
  const { children } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <>
      <div className="public-layout">
        <div className="content d-flex flex-row justify-content-center">
          {children}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(PublicLayout);

